import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class Header {
    constructor() {
        Header.sticky()
        Header.burger()
        Header.swiperBanner()
        Header.autoAdjustHomePartners()
    }

    static sticky() {
        let last_scroll_top = 0

        $(window).on('load scroll', function () {
            const offset = 200 //Trigger offset (~header height)
            const scroll_top = $(this).scrollTop()
            const $navbar = $('[data-id="wpiris-navbar"]')

            if (scroll_top >= last_scroll_top && scroll_top > $navbar.outerHeight()) {
                $('body').addClass('header-is-hidden')
            } else {
                $('body').removeClass('header-is-hidden')
            }

            last_scroll_top = scroll_top

            if (scroll_top > offset) {
                $navbar.removeClass('header__navbar--ontop')
                $navbar.addClass('header__navbar--onscroll')
            } else {
                $navbar.removeClass('header__navbar--onscroll')
                $navbar.addClass('header__navbar--ontop')
            }
        })
    }

    static burger() {
        const trigger = '[data-trigger="wpiris-menu-toggle"]'
        const more = '[data-trigger="wpiris-menu-more"]'
        const prev = '[data-trigger="wpiris-menu-prev"]'
        const submenu = '[data-trigger="wpiris-menu-submenu"]'

        $(trigger).on('click', function () {
            $('body').toggleClass('menu-open')
            $(this).toggleClass('tools__item__burger--open')
            $(submenu).removeClass('submenu-open')
        })

        $(more).on('click', function () {
            $(this).next(submenu).toggleClass('submenu-open')
        })

        $(prev).on('click', (e) => {
            e.preventDefault()
            $(submenu).removeClass('submenu-open')
        })
    }

    static async swiperBanner() {
        const options = {
            // Optional parameters
            direction: 'horizontal',
            loop: true,
            autoplay: {
                delay: 3000,
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            grabCursor: true,
            speed: 1000,
            lazy: {
                loadPrevNext: true,
            },

            // If we need pagination
            pagination: {
                el: '[data-swiper-pagination="banner"]',
                type: 'custom',
                renderCustom: (swiper, current, total) => {
                    if (current < 10 || total < 10) {
                        current = `0${current}`
                        total = `0${total}`
                    }

                    return `
						<div class="header__heading__arrows__number">${current}</div>
                		<div class="header__heading__arrows__separator swiper__icon fi fi--separator"></div>
                		<div class="header__heading__arrows__number">${total}</div>`
                },
            },

            // Navigation arrows
            navigation: {
                nextEl: '#banner-slider-button-next',
                prevEl: '#banner-slider-button-prev',
            },
        }

        $('[data-swiper="banner"] > div')
            .wrapAll('<div class="swiper-wrapper"></div>')
            .addClass('swiper-slide')

        await Swiper.create('[data-swiper="banner"]', options)
    }

    static autoAdjustHomePartners() {
        const $ecoBar = $('#eco-bar')
        const $headerContent = $('[data-id="wpiris-header-content"]')
        const $homePartners = $('[data-id="wpiris-home-partners"]')
        const $ecoBarTab = $('.eco-bar__tab')

        let ecoBarHeight = $ecoBar.outerHeight()

        if (!window.matchMedia('(max-width: 650px)').matches) {
            if ($ecoBar.length && $homePartners.length) {
                $(window).on('load', () => {
                    $headerContent.css({
                        height: `calc(100vh - ${ecoBarHeight}px)`,
                    })
                })

                $ecoBarTab.on('click', () => {
                    setTimeout(() => {
                        ecoBarHeight = $ecoBar.outerHeight()
                        $headerContent.css({
                            height: `calc(100vh - ${ecoBarHeight}px)`,
                        })
                    }, 250)
                })
            }
        }
    }
}
